import "@css/public.css";
import "@css/web/common.css";
import "@css/web/media.css";
import "@js/imglazyloading.js";

$(function(){
  $('.media-cont p').each(function(index,obj){
    let text = $(this).html()
    if(text == ''){
      $(this).remove()
    }
  });
})